import React, { useState, useEffect } from "react";
import Dashboard from "../components/AdminDashboard";
import CustomHelmet from "../components/CustomHelmet";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Spinner,
  Alert,
} from "react-bootstrap";
import AdminAdvertBlock from "../components/AdminAdvertBlock";
import Fade from "react-reveal/Fade";
import axios from "axios";

const url = "https://www.hubsquares.com/php_files/processAdvert.php/";
const urlAdvert =
  "https://www.hubsquares.com/php_files/fetchAdvert.php/";
const removeUrl =
  "https://www.hubsquares.com/php_files/removeAdvert.php/";
const AdvertAdmin = (props) => {
  const [location, setLocation] = useState("Home Page");
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [spin, setSpin] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [error, setError] = useState(false);
  const [advert, setAdvert] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListing = () => {
      axios.get(urlAdvert).then((res) => {
        setAdvert(res.data.adverts);
        setLoading(false);
      });
    };
    fetchListing();
  }, []);

  function onRemove(id) {
    let sure = window.confirm("This action will remove the advert");
    if (sure) {
      axios.post(removeUrl, { image: id }).then((res) => {
        if (res.data.success === 1) {
          alert(res.data.msg);
          props.history.push("/admin/advert");
        } else if (res.data.success === 0) {
          console.log(res.data);
        }
      });
    }
  }
  function onAdd() {
    if (image !== null && location !== "") {
      setSpin(true);
      let formData = new FormData();
      formData.append("location", location);
      formData.append("advertImg", image);
      formData.append("link", link);
      formData.append("title", title);
      axios
        .post(url, formData, {
          headers: {
            "content-type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.success === 1) {
            setSpin(false);
            setErrorValue(res.data.msg);
            setError(true);
            setTimeout(() => props.history.push("/admin/advert"), 2500);
          } else if (res.data.success === 0) {
            setErrorValue(res.data.msg);
            setSpin(false);
            setError(true);
          }
        });
    }
  }
  return (
    <>
      <CustomHelmet page="Admin Advert" />
      <Dashboard page="Adverts">
        <Container className="my-3">
          {!loading ? (
            <div>
              <h3>New Advert</h3>
              {error && (
                <div className="my-3">
                  <Fade bottom collapse when={error}>
                    <Alert
                      variant={
                        errorValue === "Advert added successful"
                          ? "success"
                          : "danger"
                      }
                    >
                      {errorValue}
                    </Alert>
                  </Fade>
                </div>
              )}
              {advert && advert.length === 4 ? (
                <div className="my-3">
                  <h5 className="text-red">
                    {" "}
                    Please remove an Advert before adding
                  </h5>
                </div>
              ) : (
                <Row className="mt-3">
                  <Col md={6} sm={12}>
                    <div className="form-group mb-3">
                      <Form.Control
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        as="select"
                      >
                        <option value="">Choose Your Advert Location</option>

                        {advert &&
                        advert.filter((list) => list.location === "Home Page")
                          .length === 3 ? null : (
                          <option value="Home Page">Home Page</option>
                        )}
                        {advert &&
                        advert.filter(
                          (list) => list.location === "Listings Page"
                        ).length === 1 ? null : (
                          <option value="Listings Page">Listings Page</option>
                        )}
                      </Form.Control>
                    </div>
                  </Col>
                  <Col md={6} sm={12}>
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        required
                        id="title"
                        className="form-control"
                        placeholder="Advert Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6} sm={12}>
                    <div className="mb-3">
                      {/* <label htmlFor="image">Advert Image</label> */}
                      <input
                        accept=".jpg,.jpeg,.png"
                        name="image"
                        id="image"
                        onChange={(e) => {
                          setImage(e.target.files[0]);
                        }}
                        type="file"
                        className="form-control"
                      />
                    </div>
                  </Col>
                  <Col md={6} sm={12}>
                    <div className="form-group">
                      <input
                        type="text"
                        required
                        id="link"
                        className="form-control"
                        placeholder="Advert Link e.g http://www.advert.com"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                      />
                      <p className="muted">optional</p>
                    </div>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    className="d-flex justify-content-start mb-3"
                  >
                    <Button
                      variant="danger"
                      onClick={onAdd}
                      disabled={spin}
                      size="lg"
                      className="addbtn"
                    >
                      <i className="fa fa-plus mr-2" />
                      Add
                      {spin && (
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </Button>
                  </Col>
                </Row>
              )}
              <Row className="mt-3">
                <Col md={12}>
                  <h3>Running Adverts</h3>

                  <div>
                    {advert &&
                      advert.map((ads, i) => (
                        <div key={i} className="mb-2">
                          <AdminAdvertBlock
                            title={ads.title}
                            section={ads.location}
                            onRemove={() => onRemove(ads.image)}
                          />
                        </div>
                      ))}
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <>
              {" "}
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
              <br />
            </>
          )}
        </Container>
      </Dashboard>
    </>
  );
};
export default AdvertAdmin;
